import { Component, Inject, Input, OnInit } from '@angular/core';
import { FlowControlService } from '../services/flow-control.service';
import { DigitalvenueConfiguration } from '../digitalvenue-configuration.model';
import { DVMService } from '../services/dvm.service';
import { DV_CONFIG, DVM_CONFIG } from '../digitalvenue.configuration';
import { DVMConfiguration } from '../dvmconfiguration.model';
import { IsolatedSeatsService } from '../services/isolated-seats.service';
import { APP_CONFIG } from '../../configuration/ticket-management-portal-configuration';
import { TicketManagementPortalConfiguration } from '../../configuration/ticket-management-portal-configuration.model';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  @Input() isSelectionAllowed;

  public previousAvailableSectionId: string | null = null;
  public nextAvailableSectionId: string | null = null;

  get isStep1() {
    if (this.dvmService.viewer) {
      return this.dvmService.viewer.getMapId() === this.dvmConfig.map_id;
    }
    return false;
  }

  get isStep2() {
    if (this.dvmService.viewer && this.dvmService.viewer.getMapId()) {
      return this.dvmService.viewer.getMapId() !== this.dvmConfig.map_id && !this.dvmService.viewer3d.getViewId();
    }
    return false;
  }

  get isStep3() {
    if (this.dvmService.viewer3d && this.dvmService.viewer3d.getViewId()) {
      return true;
    }
    return false;
  }

  back() {
    const loadOptions = JSON.parse(JSON.stringify(this.dvmConfig));
    loadOptions.venue_id = this.dvmService.viewer.getVenueId();
    if (this.isStep2) {
      this.isolatedSeats.resetBuffer();
    } else if (this.isStep3) {
      loadOptions.map_id = this.dvmService.viewer.getMapId();
      this.dvmService.viewer3d.reset();
    }
    this.dvmService.loadMap(loadOptions);
  }

  isSectionView() {
    // if (this.flowControl.suitesHash[this.dvmService.viewer3d.getViewId().split('-')[0].split('(')[0]] ||
    // this.dvmService.viewer3d.getViewId().split('-').length === 1) {
    //   return true;
    // }
    return this.flowControl.isGASelected;
  }

  get currentSection() {
    if (this.isStep3) {
      return this.dvmService.viewer3d.getViewId().split('-')[0].split('_')[1].split('(')[0];
    }
    if (this.dvmService.viewer) {
      return this.dvmService.viewer.getMapId().split('-')[0].split('_')[1];
    }
  }

  get currentRow() {
    if (this.isStep3 && this.dvmService.viewer3d.getViewId()) {
      return this.dvmService.viewer3d.getViewId().split('-')[1];
    }
  }

  get currentSeat() {
    if (this.isStep3 && this.dvmService.viewer3d.getViewId()) {
      return this.dvmService.viewer3d.getViewId().split('-')[2];
    }
  }

  constructor(private flowControl: FlowControlService,
              private dvmService: DVMService,
              private isolatedSeats: IsolatedSeatsService,
              @Inject(DVM_CONFIG) public dvmConfig: DVMConfiguration,
              @Inject(DV_CONFIG) public dvConfig: DigitalvenueConfiguration,
              @Inject(APP_CONFIG) public appConfig: TicketManagementPortalConfiguration) { }

  ngOnInit() {
    // subscribe to endload to calculate previous and next sections
    this.dvmService.subscribeHandler('end_load', this.onChangeSection.bind(this));
  }

  private onChangeSection(error, viewer) {
    viewer = viewer.instance;
    const mapId = viewer.getMapId();
    this.previousAvailableSectionId = null;
    this.nextAvailableSectionId = null;
    // if we are not in the topview, calculate next and prev section values in order to do neighbour navigation
    if (viewer.getMapId() !== this.dvmConfig.map_id && this.appConfig.neighbours) {
      this.setNeighbourSection('next', mapId, 25, 0);
      this.setNeighbourSection('prev', mapId, 25, 0);
    }
  }

  private setNeighbourSection(
    type: 'prev' | 'next',
    currentSectionMmcId: string,
    maxIterations: number,
    iterationCount: number,
  ): void {
    // add 1 to iteration count
    iterationCount++;
    const noNeighbourValue = 'none';
    const neighbourKey = type === 'prev' ? 'l' : 'r';

    const neighbourInfo = this.appConfig.neighbours[currentSectionMmcId];
    const neighbourSection = neighbourInfo[neighbourKey];
    // we test if has availability searching in the flowControl availability obbject
    const hasAvailability =
      !!this.flowControl.availabilty.getValue()[neighbourSection];

    // if has availability we have the next or previous
    if (neighbourSection && hasAvailability) {
      if (type === 'prev') {
        this.previousAvailableSectionId = neighbourSection;
      }
      if (type === 'next') {
        this.nextAvailableSectionId = neighbourSection;
      }
      return;
    }
    // if doesn't have availability and we are at the edge or at max iterations, then the node has no neighbour in this direction
    if (neighbourSection === noNeighbourValue || iterationCount === maxIterations) {
      if (type === 'prev') {
        this.previousAvailableSectionId = null;
      }
      if (type === 'next') {
        this.nextAvailableSectionId = null;
      }
      return;
    }
    // continue searching if the two conditions above are not met
    return this.setNeighbourSection(type, neighbourSection, maxIterations, iterationCount++);
  }

  public changeSection(goTo: 'prev' | 'next') {
    const sectionId =
      goTo === 'prev'
        ? this.previousAvailableSectionId
        : this.nextAvailableSectionId;

    if (!sectionId) {
      return;
    }
    const loadOptions = JSON.parse(JSON.stringify(this.dvmConfig));
    loadOptions.map_id = sectionId;
    loadOptions.venue_id = this.dvmService.viewer.getVenueId();
    this.dvmService.loadMap(loadOptions);
  }

}
